var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHeidelbergMaterials(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_14605_3343)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M80 80H30.7584C12.3034 80 0 67.6966 0 49.2416V0H49.2134C67.6684 0 79.9718 12.3034 79.9718 30.7584V80H80Z",
    fill: "#004E2B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.0618 27.6825H49.2134C60.6984 27.6825 67.6685 34.6807 67.6685 46.1375V67.6684H61.5168C50.2011 67.6684 43.0618 60.4444 43.0618 49.2134V27.6825Z",
    fill: "#00DD39"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.3035 12.3033H36.9102V67.6684H30.7585C19.3299 67.6684 12.3035 60.7548 12.3035 49.2134V12.3033Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_14605_3343"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeidelbergMaterials);
export default __webpack_public_path__ + "static/media/HeidelbergMaterials.4fd9f6b886bdfe388780445f4d8bd6e6.svg";
export { ForwardRef as ReactComponent };